import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { has as _has } from 'lodash-es';
import { Observable, Subject } from 'rxjs';
import { map, retry, shareReplay, takeUntil } from 'rxjs/operators';
import { BadgeDataResponse } from '../../shared/models/badge-data-response';
import { TargetChallengeDataResponse } from '../../shared/models/target-challenge-data-response';

import { TargetChallengePeriodData } from '../../shared/models/target-challenge-period-data';

const API_ENDPOINT = '/api/targetchallenge/';

@Injectable({
  providedIn: 'root',
})
export class BadgeService {

  private badges: Observable<TargetChallengePeriodData[]>[] = [];
  private reload = new Subject<void>();

  /**
   * Constructor
   *
   * @param http HttpClient
   */
  public constructor(private http: HttpClient) {
  }

  /**
   * Gets the TargetChallengeData items.
   *
   * @return {Observable<TargetChallengeDataResponse>}
   */
  public getDataItemsForType(type: string): Observable<BadgeDataResponse> {
    if (!_has(this.badges, type)) {
      this.badges[type] = this.loadDataForType(type).pipe(
        shareReplay(1),
        takeUntil(this.reload),
      );
    }

    return this.badges[type];
  }

  /**
   * Loads the required TargetChallengeData for the given type
   *
   * @returns Observable<TargetChallengeDataResponse>
   */
  public loadDataForType(type: string): Observable<BadgeDataResponse> {
    return this.http.get(API_ENDPOINT + 'badge/get/data')
      .pipe(
        retry(3),
        map(
          (response: { error: string, items: BadgeDataResponse }) => {
            return response.items;
          },
        ),
      );
  }

  /**
   * Force the active player to refresh
   * @return void
   */
  public forceReload(): void {
    this.reload.next();
    this.badges = [];
  }
}
